export const OVERALLPERFORMANCESALLSUBTITLE_REQUEST =
  "OVERALLPERFORMANCESALLSUBTITLE_REQUEST";
export const OVERALLPERFORMANCESALLSUBTITLE_SUCCESS =
  "OVERALLPERFORMANCESALLSUBTITLE_SUCCESS";
export const OVERALLPERFORMANCESALLSUBTITLE_FAIL =
  "OVERALLPERFORMANCESALLSUBTITLE_FAIL";
